export default {
	tenantId: "coverLibrary_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "coverlibrary--uat"
	}
}
